export default __webpack_public_path__ + "static/img-nhs-kortical-bc89fe2da9e5e2a0e8011a3aea144ec9.jpg";